import React, { useState } from 'react';

const DebugImage = ({ src, alt, className, onClick, ...props }) => {
  const [error, setError] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const handleLoad = () => {
    console.log('✅ Image loaded successfully:', src);
    setLoaded(true);
  };

  const handleError = (e) => {
    console.error('❌ Image failed to load:', src, e);
    setError(true);
  };

  if (error) {
    return (
      <div 
        className={`${className} bg-red-100 border-2 border-red-300 flex items-center justify-center`}
        style={{ minHeight: '150px' }}
      >
        <div className="text-red-600 text-center p-2">
          <div className="text-sm font-semibold">Failed to load</div>
          <div className="text-xs mt-1 break-all">{src}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="relative">
      {!loaded && (
        <div className={`${className} bg-gray-200 flex items-center justify-center`}>
          <div className="text-gray-500 text-sm">Loading...</div>
        </div>
      )}
      <img
        src={src}
        alt={alt}
        className={className}
        onClick={onClick}
        onLoad={handleLoad}
        onError={handleError}
        style={{ display: loaded ? 'block' : 'none' }}
        {...props}
      />
    </div>
  );
};

export default DebugImage;